import { Select, SelectProps } from 'antd';
import { useGetAllCultureQuery } from 'app/api';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IOption } from 'types';

interface IProps extends SelectProps<number> {}

const CultureSelect: FC<IProps> = props => {
  const { t } = useTranslation();

  const { data, isFetching } = useGetAllCultureQuery();

  const options: IOption[] | undefined = data?.map(culture => ({
    value: culture.id,
    label: culture.name,
  }));

  return (
    <Select
      showSearch
      filterOption={(input, option) => {
        const label = (option?.label as string)?.toLowerCase();
        return label?.includes(input.toLowerCase());
      }}
      options={options}
      loading={isFetching}
      dropdownMatchSelectWidth={false}
      placeholder={t('Common.Culture', 'Culture')}
      {...props}
    />
  );
};

export default CultureSelect;
